import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { CheckedListControl } from "@/Common/Components/Inputs/CheckedListControl";
import { MultiDateSelector } from "@/Common/Components/Inputs/MultiDateSelector";
import { SettingsButton } from "@/Common/Components/Settings/SettingsButton";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { IMedicationGridModel } from "@/Patient/Models/UI/Medication/IPatientMedicationGridModel";

interface IMedicalItemsSearchSettingsProps {
    Model: IMedicationGridModel;
}

class MedicalItemsearchSettings extends BaseReactComponent<IMedicalItemsSearchSettingsProps, any> {
    public componentDidMount(): void {
        super.setOverlay("MedicalItemsearchSettings", { transparent: true });
    }

    public render(): JSX.Element {
        const fromDate = this.props.Model.get("FromDate");
        const toDate = this.props.Model.get("ToDate");
        const isDateFilterInvalid = fromDate && toDate && fromDate > toDate;

        return (
            <div>
                <table className="f-content">
                    <thead>
                        <tr>
                            <th className="first">
                                <label className="uppercase">{cacheStore.GetString("lblDSQPrescriptionOrderDate")}</label>
                            </th>
                            <th>
                                <CheckboxControl
                                    id="status_check"
                                    label={cacheStore.GetString("PrescriptionStatusLabel").toUpperCase()}
                                    operation={LocalPatientOperations.MedicationGrid.SearchStatusChanged}
                                    checked={this.props.Model.get("IsAllStatusChecked")}
                                    target={CheckboxTarget.Myle_PatientCPP_MedicationSearch_Status_AllCheck}
                                />
                            </th>
                            <th>
                                <CheckboxControl
                                    id="origin_check"
                                    label={cacheStore.GetString("OriginLabel").toUpperCase()}
                                    operation={LocalPatientOperations.MedicationGrid.SearchOriginChanged}
                                    checked={this.props.Model.get("IsAllOriginChecked")}
                                    target={CheckboxTarget.Myle_PatientCPP_MedicationSearch_Origin_AllCheck}
                                />
                            </th>
                            <th>
                                <CheckboxControl
                                    id="details_check"
                                    label={cacheStore.GetString("DetailsMLabel").toUpperCase()}
                                    operation={LocalPatientOperations.MedicationGrid.SearchDetailsChange}
                                    checked={this.props.Model.get("IsAllDetailsChecked")}
                                    target={CheckboxTarget.Myle_PatientCPP_MedicationSearch_Details_AllCheck}
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="first">
                                <MultiDateSelector
                                    id="cpp_medication_search_date"
                                    fromMyleOperation={LocalPatientOperations.MedicationGrid.SearchDateFromChanged}
                                    toMyleOperation={LocalPatientOperations.MedicationGrid.SearchDateToChanged}
                                    fromSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                    toSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                    from={fromDate}
                                    to={toDate}
                                />
                            </td>
                            <td className="sites-column">
                                <CheckedListControl DataSource={this.props.Model.get("StatusChecks")} Operation={LocalPatientOperations.MedicationGrid.SearchStatusChanged} />
                            </td>
                            <td className="sites-column">
                                <CheckedListControl DataSource={this.props.Model.get("OriginChecks")} Operation={LocalPatientOperations.MedicationGrid.SearchOriginChanged} />
                            </td>
                            <td className="sites-column">
                                <CheckedListControl DataSource={this.props.Model.get("DetailsChecks")} Operation={LocalPatientOperations.MedicationGrid.SearchDetailsChange} />
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div className="f-footer clearfix">
                    <div className="pull-left">
                        <SettingsButton alternativeIcon={true} rightMargin={5} onClickOperation={LocalPatientOperations.MedicationGrid.ColumnsSettingOpen} />
                    </div>

                    <div className="pull-right">
                        <ButtonGroup>
                            <ButtonControl
                                className="btn btn-default"
                                onClick={() => sessionStore.dispatch(LocalPatientOperations.MedicationGrid.SettingsCancel)}
                                label={cacheStore.GetString("CancelLabel")}
                            />
                            <ButtonControl
                                className="btn btn-primary"
                                onClick={() => sessionStore.dispatch(LocalPatientOperations.MedicationGrid.SettingsOk)}
                                label={cacheStore.GetString("Ok_Label")}
                                disabled={isDateFilterInvalid}
                            />
                        </ButtonGroup>
                    </div>
                </div>
            </div>
        );
    }
}

export { MedicalItemsearchSettings };
